export default "__VITE_ASSET__CEQ5JfgS__"